var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 39,
    height: 39,
    fill: "#E2DEFF",
    stroke: "#4A03A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27V29.5C31.5 31.43 29.93 33 28 33H18C16.07 33 14.5 31.43 14.5 29.5V28.85C14.5 27.28 15.78 26 17.35 26H30.5C31.05 26 31.5 26.45 31.5 27Z",
    fill: "#4A03A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 13H19.5C15.5 13 14.5 14 14.5 18V25.58C15.26 24.91 16.26 24.5 17.35 24.5H30.5C31.05 24.5 31.5 24.05 31.5 23.5V18C31.5 14 30.5 13 26.5 13ZM24 21.75H19C18.59 21.75 18.25 21.41 18.25 21C18.25 20.59 18.59 20.25 19 20.25H24C24.41 20.25 24.75 20.59 24.75 21C24.75 21.41 24.41 21.75 24 21.75ZM27 18.25H19C18.59 18.25 18.25 17.91 18.25 17.5C18.25 17.09 18.59 16.75 19 16.75H27C27.41 16.75 27.75 17.09 27.75 17.5C27.75 17.91 27.41 18.25 27 18.25Z",
    fill: "#4A03A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCard3);
export default __webpack_public_path__ + "static/media/benefit-card-3.0a8a6a4a451fe2e36bcdc68466cc0535.svg";
export { ForwardRef as ReactComponent };